import type { FC, SVGProps } from 'react';

import ArrowRightIconSvg from './arrow-right.svg';

/** Иконка стрелки вправо (навигация календаря). */
const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = ArrowRightIconSvg;

export default ArrowRightIcon;
